export class ListConnectorsResponse {
    'connectors';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "connectors",
            "baseName": "connectors",
            "type": "Array<Connector>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListConnectorsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
